import { greys, colors } from "@styles/color.styles";
import { fontFamilyIdealSans, fontFamilyHelvetica } from "@styles/type.styles";
import { makeStyles } from "@material-ui/styles";

export const narrowCutoff = 560;

export const narrowMediaQuery = `@media (max-width: ${narrowCutoff}px)`;

export const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    minHeight: 640,

    [narrowMediaQuery]: {
      flexWrap: "wrap",
      height: "unset",
      minHeight: "unset",

      "& ::-webkit-scrollbar": {
        background: "transparent" /* Chrome/Safari/Webkit */,
        width: 0,
      },

      scrollbarWidth: "none",
      msOverflowStyle: "none",
    },

    "&.opaque": {
      "& > div": {
        opacity: 0.3,
      },
    },
  },
  leftContent: {
    marginLeft: 40,
    marginTop: 26,
    maxWidth: 330,
    flexShrink: 0,

    "& .MuiPickersBasePicker-pickerView": {
      maxWidth: "unset",
    },

    [narrowMediaQuery]: {
      flexGrow: 1,
      flexShrink: 1,
      marginLeft: 30,
      maxWidth: "98%",

      "& .MuiPickersBasePicker-pickerView": {
        maxWidth: "calc(100vw - 50px)",
      },

      "& .MuiPickersCalendarHeader-transitionContainer": {
        maxWidth: 275,
      },
    },
  },
  timesForDays: {
    flexGrow: 2,
    flexShrink: 1,
    minWidth: 250,
    margin: "24px 15px 15px 71px",
    maxHeight: "70vh",
    display: "flex",
    flexDirection: "column",

    [narrowMediaQuery]: {
      margin: "38px 13px 20px 18px",
      maxHeight: "95%",
    },
  },
  dateHeaderAndCalendar: {
    marginLeft: -19,
  },
  rightContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1,
    alignSelf: "center",
  },
  linkHasNoTimes: {
    backgroundColor: greys.paleGrey,
    borderRadius: "50%",
    padding: 20,
    height: 230,
    width: 230,
    display: "flex",
    alignItems: "center",
    maxWidth: 550,
    margin: 50,

    "& > span": {
      textAlign: "center",
      color: greys.slate,
      fontFamily: fontFamilyHelvetica,
      overflow: "hidden",
      lineHeight: "140%",
    },
  },
  hasTimes: {
    "& .MuiPickersDay-day": {
      backgroundColor: colors.green.lightest,
    },

    "& .MuiPickersDay-daySelected": {
      backgroundColor: colors.green.standard,
    },
  },
  hasNoTimes: {
    "& .MuiPickersDay-daySelected": {
      backgroundColor: greys.blueGrey,
    },
    "& .MuiPickersDay-current": {
      color: "#263238", // Default color.
    },
  },
  calendarHeader: {
    "& .MuiPickersCalendar-transitionContainer": {
      marginBottom: 18, // Should be 3x .MuiPickersCalendar-week
    },

    "& .MuiPickersCalendarHeader-daysHeader": {
      justifyContent: "space-around",
    },

    "& .MuiPickersCalendar-week": {
      marginBottom: 3,
      justifyContent: "space-around",
    },

    "& .MuiPickersCalendarHeader-transitionContainer > p": {
      fontFamily: fontFamilyIdealSans,
      fontSize: "1.3rem",
      fontWeight: "bold",
      color: colors.blueDusk.darker,
      marginTop: -4,
    },

    "& .MuiSvgIcon-root": {
      // Left right chevrons.
      fontSize: "1.8rem",
    },

    [narrowMediaQuery]: {
      "& .MuiPickersCalendar-week": {
        justifyContent: "space-evenly",
        marginBottom: 4,
      },

      "& .MuiPickersCalendarHeader-daysHeader": {
        justifyContent: "space-evenly",
      },

      // Give extra height to account for increased .MuiPickersCalendar-week marginBottom
      // and .MuiPickersDay-day circle radius.
      "& .MuiPickersCalendar-transitionContainer": {
        marginBottom: 48,
      },

      // Increase radius of date circles.
      "& .MuiPickersDay-day": {
        height: 40,
        width: 40,
      },
    },
  },
  calendarTopRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    [narrowMediaQuery]: {
      display: "none",
    },
  },
  logoConfirmation: {
    width: 165,
  },
  logoMainPage: {
    width: 165,
    margin: "40px 40px 18px",

    [narrowMediaQuery]: {
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: 15,
      alignSelf: "center",
    },
  },
});
